import React from 'react'
import DigidApp from '../../components/DigidApp'
import _ from 'lodash'

const AppButtons = ({ entity }) => {
  const props = {
    appStore: _.get(entity, 'fieldAppstoreUrl.url.path', null),
    playStore: _.get(entity, 'fieldPlaystoreUrl.url.path', null),
    title: _.get(entity, 'fieldTitle', ''),
    text: _.get(entity, 'fieldSmallText', ''),
    backgroundImage: _.get(entity, 'fieldBackground.entity.fieldMediaImage.cardImage.image.childImageSharp', ''),
  }

  return (
    <DigidApp {...props} />
  );
}

export default AppButtons
